import { render, staticRenderFns } from "./DAttributeEditorComponent.vue?vue&type=template&id=5c940471&scoped=true"
import script from "./DAttributeEditorComponent.vue?vue&type=script&lang=js"
export * from "./DAttributeEditorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c940471",
  null
  
)

export default component.exports